/**
 * Generates tuples from given iterable args.
 *
 * @yields {*}
 */
export default function *(...args) {
    const iterators = args.map(arg => arg[Symbol.iterator]());

    while (true) {
        const results = iterators.map(iterator => iterator.next());

        if (results.some(result => result.done)) {
            return results.map(result => result.value);
        }

        yield results.map(result => result.value);
    }
}
